module.exports = __webpack_public_path__ + "assets/img/logo.a71fe48f.jpg";